import { Tooltip } from 'antd';
import React from 'react';
import { FieldItemType, FieldItemProps } from './index';
import './fielditem.scss';
import PreviewList from '../PreviewList';
const FieldItem = (props: FieldItemProps) => {
  const {
    label,
    value,
    values,
    type,
    fieldKey,
    unit,
    icon,
    handleClickItem,
    slot,
    children,
    showPreviewName,
  } = props;
  return (
    <div className='fields-group-item'>
      <span className='label-text'>{label}</span>
      {type == FieldItemType.snapshot ? (
        values && values.length > 0 ? (
          <PreviewList
            fileList={values}
            fill={false}
            onPreview={(file: any) => {}}
            showPreviewName={showPreviewName}
          />
        ) : (
          <span className='value-text'>{value}</span>
        )
      ) : children ? (
        children
      ) : (
        <>
          {typeof value !== 'number' && !value ? (
            <span className='value-text'>--</span>
          ) : (
            <Tooltip title={value}>
              <span className='value-text'>
                {value} {unit}
              </span>
            </Tooltip>
          )}
          {icon && (
            <span
              className='icon'
              onClick={() => {
                handleClickItem && handleClickItem(fieldKey);
              }}
            >
              {icon}
            </span>
          )}
          {slot}
        </>
      )}
    </div>
  );
};

export default React.memo(FieldItem);
